/**
 * distance.js
 */

import { differenceInMilliseconds } from 'date-fns';


export const DISTANCE_UNIT_NAME = {
  MILES: 'MILES',
  YARDS: 'YARDS',
  FEET: 'FEET',
  KILOMETERS: 'KILOMETERS',
  METERS: 'METERS'
};


export const DISTANCE_UNIT_DDV = {
  MILES: 4725,
  YARDS: 4726,
  FEET: 4727,
  KILOMETERS: 4728,
  METERS: 4729
};


const unitIndexes = Object.freeze({
  MILES : 0,
  YARDS: 1,
  FEET: 2,
  KILOMETERS: 3,
  METERS: 4
});


// unit conversion matrix. E.g. mile -> km. 1 mile = (1 * conversionMatrix[0][3]) km
const conversionMatrix = [
  [1, 1760, 5280, 1.60934, 1609.34],
  [0.000568182, 1, 3, 0.0009144, 0.9144],
  [0.000189394, 0.333333, 1, 0.0003048, 0.3048],
  [0.621371, 1093.61, 3280.84, 1, 1000],
  [0.000621371, 1.09361, 3.28084, 0.001, 1]
];


const roundDecimal2 = (value) => {
  return Math.round(value * 100) / 100;
}


// usage: convertDistance(420, DISTANCE_UNIT_NAME.METERS, DISTANCE_UNIT_NAME.YARDS)
export const convertDistance = (distance, fromUnit, toUnit) => {
  if (!fromUnit || !toUnit) return null;

  const fromUnitIndex = unitIndexes[fromUnit.toUpperCase()];
  const toUnitIndex = unitIndexes[toUnit.toUpperCase()];
  if (fromUnitIndex !== undefined && toUnitIndex !== undefined && !isNaN(distance)) {
    return roundDecimal2(distance * conversionMatrix[fromUnitIndex][toUnitIndex]);
  }

  return null;
}


// determines distance (meters) between 2 coordinates
export const getDistanceFromLatLonM = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1); 
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
  var d = R * c; // Distance in km
  return roundDecimal2(d * 1000);
}


const deg2rad = (deg) => {
  return deg * (Math.PI/180)
}


// determines track distance (meters)
export const getTrackDistanceM = (points) => {
  const distance = points.reduce((prev, point, i) => {
    const prevPoint = i === 0 ? null : points[i - 1];
    const segmentDistance = prevPoint ? getDistanceFromLatLonM(point.latitude, point.longitude, prevPoint.latitude, prevPoint.longitude) : 0;
    return prev + segmentDistance;
  }, 0);
  return roundDecimal2(distance);
}


// determines speed (meters/second) between 2 points
export const getCalculatedSpeedMS = (point1, point2) => {
  const distance = getDistanceFromLatLonM(point1.latitude, point1.longitude, point2.latitude, point2.longitude);
  const time = differenceInMilliseconds(point2.dateTimeCreated, point1.dateTimeCreated) / 1000;
  return time !== 0
    ? Math.round(distance / time * 10) / 10
    : 0;
}